import { BaseEntity } from '../../base-entity';

export enum WorkingHoursRefType {
  Lecture = 'lecture',
}

export enum WorkingHoursStatus {
  PendingForApproval = 'pendingForApproval',
  Approved = 'approved',
  Suspended = 'suspended',
  Reject = 'reject',
}

export interface WorkingHoursEntity2 extends BaseEntity {
  id: number;
  userId: number;
  activityTypeId: number;
  activityTypeName: string;
  branchLecturersRates: number;
  branchLecturersRatesId: number;
  startAt: Date;
  endAt: Date;
  versionNumber: number;
  parentRecordId: number;
  isManual: boolean;
  entityType: WorkingHoursRefType | null;
  entityRefId: number | null;
  status: WorkingHoursStatus;

  parentId: number | null;
  isActive: boolean;
}

export interface WorkingHoursResponse extends WorkingHoursEntity2 {
  history: WorkingHoursEntity2[];
}
